module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-120x120-232daedcd8997516febd101550a3b855.png";